import {defaultHandlerCatch, defaultHandlerResolver, promisifyImage} from "./helpers";
import {photolabTask} from "../api";
import {extraKeys} from "../etc";
import {PhotolabTaskBuilder} from "@vicman-wi/photolab-api-js";

const tasksCache = {};

function photolabTaskHelper(creative, taskName, taskConfig, options) {
  const taskCacheKey = JSON.stringify(taskConfig);
  const _options = Object.assign({
    timeout: 1000,
    interval: 1000,
  }, options);

  if (!tasksCache[taskCacheKey]) {
    tasksCache[taskCacheKey] = photolabTask(taskConfig, {
      timeout: _options.timeout,
      interval: _options.interval,
    })
  }

  return tasksCache[taskCacheKey].then((taskResult) => {
    creative.setTask(taskName, taskResult);
    return taskResult;
  }).catch((err) => {
    delete tasksCache[taskCacheKey];
    throw err;
  });
}

async function promptTask(processing, creative, userFile) {
  const promptValues = {
    gender: processing.getExtra(extraKeys.gender),
    age_group: processing.getExtra(extraKeys.ageGroup),
    race: processing.getExtra(extraKeys.race),
    skin_color: processing.getExtra(extraKeys.skinColor),
    hair_length: processing.getExtra(extraKeys.hairStyle2),
    hair_color: processing.getExtra(extraKeys.hairColor2),
  };

  return await photolabTaskHelper(creative, "prompt", new PhotolabTaskBuilder()
    .setLanguage(processing.language)
    .addCollageMethod({
      "@transformationId": "npp_base",
      "@configId": creative.getExtra("config_id"),
      "@values": [
        {
          parameters: ["prompt"],
          values: promptValues,
        },
      ],
      param_sds: creative.getExtra(extraKeys.seed),
      gender: processing.getExtra(extraKeys.gender),
    })
    .addImage(userFile.url)
    .setLanguage(processing.language)
    .build());
}

/**
 * @param {Processing} processing
 * @param {Creative} creative
 */

export default (processing, creative, options) => {
  return new Promise(async (resolve, reject) => {
    try {
      options = Object.assign({}, options);

      const userFile = processing.file;

      const promptTaskResult = await promptTask(processing, creative, userFile);

      await promisifyImage(promptTaskResult.resultUrl);

      creative.setFile("raw", promptTaskResult.resultUrl);
      creative.markAsProcessed(promptTaskResult.resultUrl);

      defaultHandlerResolver(creative, resolve)();
    } catch (err) {
      defaultHandlerCatch(creative, reject)(err);
    }
  });
}